(function () {
  const COLOR_OPTION_NAMES = ['color', 'colour', '색상'];

  function normalizeValue(value) {
    return (value || '').toString().trim().toLowerCase();
  }

  function isColorOptionName(name) {
    return COLOR_OPTION_NAMES.includes(normalizeValue(name));
  }

  function getSwatchColor(name) {
    const key = normalizeValue(name);

    const map = {
      'off white': '#f5f1e8',
      'off-white': '#f5f1e8',
      'ivory': '#f5f1e8',
      'cream': '#f5f1e8',
      'beige': '#d8c3a5',
      'sand': '#cdbb9a',
      'tan': '#b68b5e',
      'camel': '#b68b5e',
      'brown': '#6b4f3a',
      'mocha': '#6b4f3a',
      'chocolate': '#6b4f3a',
      'black': '#111111',
      'white': '#ffffff',
      'grey': '#8a8a8a',
      'gray': '#8a8a8a',
      'charcoal': '#36454f',
      'silver': '#c0c0c0',
      'gold': '#d4af37',
      'navy': '#1f2a44',
      'blue': '#3366cc',
      'light blue': '#8ecae6',
      'sky blue': '#8ecae6',
      'sky-blue': '#8ecae6',
      'green': '#4f7d4f',
      'olive': '#7a8b5b',
      'sage': '#7a8b5b',
      'red': '#c0392b',
      'burgundy': '#7b1e3a',
      'wine': '#7b1e3a',
      'pink': '#e8b4b8',
      'blush': '#e8b4b8',
      'yellow': '#d4a017',
      'mustard': '#d4a017',
      'orange': '#c96f3b',
      'rust': '#c96f3b',
      'terracotta': '#c96f3b',
      'purple': '#9b7edc',
      'lavender': '#9b7edc'
    };

    return map[key] || key || '#dddddd';
  }

  function initCardSwatches(root) {
    const scope = root || document;

    scope.querySelectorAll('[data-product-card-swatches]').forEach(function (group) {
      if (group.dataset.swatchesReady === 'true') return;
      group.dataset.swatchesReady = 'true';

      const card = group.closest('.card-wrapper, .card');
      if (!card) return;

      const mainImg =
        card.querySelector('.card__media img') ||
        card.querySelector('.media img') ||
        card.querySelector('img');

      if (!mainImg) return;

      if (!mainImg.dataset.originalSrc) {
        mainImg.dataset.originalSrc = mainImg.getAttribute('src') || '';
      }

      if (!mainImg.dataset.originalSrcset) {
        mainImg.dataset.originalSrcset = mainImg.getAttribute('srcset') || '';
      }

      group.querySelectorAll('.custom-card-swatches__item').forEach(function (item) {
        item.addEventListener('mouseenter', function () {
          const image = this.dataset.swatchImage;
          if (!image) return;

          mainImg.setAttribute('src', image);
          if (mainImg.hasAttribute('srcset')) {
            mainImg.removeAttribute('srcset');
          }
        });

        item.addEventListener('mouseleave', function () {
          const originalSrc = mainImg.dataset.originalSrc || '';
          const originalSrcset = mainImg.dataset.originalSrcset || '';

          if (originalSrc) {
            mainImg.setAttribute('src', originalSrc);
          }

          if (originalSrcset) {
            mainImg.setAttribute('srcset', originalSrcset);
          }
        });
      });
    });
  }

  function initPdpSwatches(root) {
    const scope = root || document;

    scope.querySelectorAll('fieldset').forEach(function (fieldset) {
      if (fieldset.dataset.colorSwatchReady === 'true') return;

      const legend =
        fieldset.querySelector('legend') ||
        fieldset.querySelector('.form__label');

      if (!legend) return;

      const legendText = normalizeValue(legend.textContent);
      if (!isColorOptionName(legendText)) return;

      fieldset.dataset.colorSwatchReady = 'true';
      fieldset.classList.add('custom-pdp-color-fieldset');

      fieldset.querySelectorAll('input[type="radio"] + label').forEach(function (label) {
        const labelText = (label.textContent || '').trim();
        const swatchColor = getSwatchColor(labelText);

        label.classList.add('custom-pdp-color-label');
        label.setAttribute('title', labelText);
        label.setAttribute('data-color-swatch', swatchColor);
        label.style.setProperty('--swatch-bg', swatchColor);
      });
    });
  }

  function initAll(root) {
    initCardSwatches(root);
    initPdpSwatches(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:reorder', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    initAll(event.target);
  });
})();